import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--receipts--calculator"
export default class extends Controller {
  static targets = [
    "income",
    "expense",
    "initialView",
    "incomesView",
    "expensesView",
    "balancesView",
    "initialField",
    "incomesField",
    "expensesField",
    "balancesField",
  ]

  expenseTargetConnected(event) {
    this.calculate()
  }

  expenseTargetDisconnected(event) {
    this.calculate()
  }

  incomeTargetConnected(event) {
    this.calculate()
  }

  incomeTargetDisconnected(event) {
    this.calculate()
  }

  calculate() {
    let initialAmount = parseInt(this.initialFieldTarget.value)
    let totalAmount = 0
    let expenseAmount = 0

    this.incomeTargets.forEach((income) => {
      let incomes = income.querySelectorAll("input[data-field='amount']")

      incomes.forEach((input) => { totalAmount += parseInt(input.value) || 0 })
    })

    this.expenseTargets.forEach((expense) => {
      let expenses = expense.querySelectorAll("input[data-field='amount']")

      expenses.forEach((input) => { expenseAmount += parseInt(input.value) || 0 })
    })

    if (this.hasIncomesViewTarget) { this.incomesViewTarget.value = this.formattedAmount(totalAmount) }
    if (this.hasExpensesViewTarget) { this.expensesViewTarget.value = this.formattedAmount(expenseAmount) }
    if (this.hasBalancesViewTarget) { this.balancesViewTarget.value = this.formattedAmount(initialAmount + totalAmount - expenseAmount) }

    this.incomesFieldTarget.value = totalAmount
    this.expensesFieldTarget.value = expenseAmount
    this.balancesFieldTarget.value = initialAmount + totalAmount - expenseAmount
  }

  formattedAmount(value) {
    return (value / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
}
